/* global Quint */
import TweenMax from 'gsap';

(() => {
  const hero = document.querySelector('.m01');

  if (hero === null) return;

  const strapFaded = () => {
    document.querySelectorAll('.stagger-in').forEach(e => {
      e.style.display = 'none';
    });
    TweenMax.to('.intro-text', 1.5, {
      ease: Quint.easeOut,
      opacity: 1,
      x: 47,
    });
  };

  const strapComplete = () => {
    TweenMax.staggerTo('.stagger-in', 1, { opacity: 0 }, 0, strapFaded);
  };

  setTimeout(() => {
    hero.classList.add('m01--animate');
    setTimeout(() => {
      TweenMax.staggerTo('.stagger-in', 1.5, {
        ease: Quint.easeOut,
        opacity: 1,
        x: 40,
      }, 0.3, strapComplete);
    }, 500);
  }, 1000);
})();



// WEBPACK FOOTER //
// ./assets/js/src/home-animation.js